
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";
import { productsImages } from "../data/dummyData";
import { MdPhone } from "react-icons/md";

const Product = () => {
  return (
    <div className="pt-16 max-w-7xl mx-auto px-4">
      <div className="grid grid-cols-1 gap-3 mt-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {productsImages.map(({ id, image,name,role }) => (
          <div className="h-[250px] w-full mb-16" key={id}>
            <img
              src={image}
              // alt={name}
              className="object-cover border-2 shadow p-8 w-full h-full rounded-lg group-hover:scale-125 transition-a"
            />
            <div className="relative z-10 w-4/5 p-2 mx-auto -mt-8 text-center bg-white rounded-lg shadow-md dark:bg-dark-light">
              <h1 className="text-lg font-semibold">{name}</h1>
              {/* <p>{role}</p> */}
              
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Product;
